import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWoodenhamsterLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 201 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	x: "0px",
	y: "0px",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M38.9753 27.0741C31.5006 27.0741 25.4238 21.0183 25.4238 13.5703C25.4238 11.1804 26.0514 8.86016 27.2429 6.81061C27.1714 6.48577 27.1317 6.1532 27.1317 5.8129C27.1317 3.19101 29.3241 1.05638 32.0169 1.05638C32.4855 1.05638 32.9542 1.12599 33.407 1.25747C35.1466 0.476317 37.053 0.0664062 38.9753 0.0664062C40.8977 0.0664062 42.7564 0.468583 44.4722 1.22653C44.8853 1.11825 45.3222 1.05638 45.759 1.05638C48.4519 1.05638 50.6443 3.19101 50.6443 5.8129C50.6443 6.07586 50.6204 6.33882 50.5807 6.59405C51.8596 8.69774 52.5269 11.0876 52.5269 13.5703C52.5269 21.0183 46.4501 27.0741 38.9753 27.0741ZM32.0169 4.38981C31.2067 4.38981 30.5473 5.03175 30.5473 5.82063C30.5473 6.01399 30.5871 6.20734 30.6665 6.38523L31.024 7.19731L30.5315 7.9398C29.4194 9.61038 28.8395 11.5594 28.8395 13.5703C28.8395 19.1775 33.3832 23.7407 38.9753 23.7407C44.5675 23.7407 49.1112 19.1775 49.1112 13.5703C49.1112 11.4975 48.4916 9.5021 47.3239 7.80058L46.8393 7.09677L47.1412 6.30015C47.1968 6.14547 47.2286 5.97532 47.2286 5.8129C47.2286 5.02401 46.5693 4.38208 45.759 4.38208C45.5366 4.38208 45.3222 4.42848 45.1236 4.52129L44.3451 4.89253L43.5825 4.49809C42.1527 3.76334 40.6037 3.3921 38.9753 3.3921C37.3469 3.3921 35.7503 3.77881 34.2967 4.53676L33.4944 4.9544L32.6921 4.54449C32.4776 4.43621 32.2552 4.38208 32.0169 4.38208V4.38981Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.9275 23.4547C50.7135 23.4547 53.7826 20.4663 53.7826 16.7801C53.7826 13.0938 50.7135 10.1055 46.9275 10.1055C43.1414 10.1055 40.0723 13.0938 40.0723 16.7801C40.0723 20.4663 43.1414 23.4547 46.9275 23.4547Z",
			fill: "#E00303"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.9263 25.1085C42.2079 25.1085 38.3633 21.3729 38.3633 16.771C38.3633 12.1692 42.2 8.43359 46.9263 8.43359C51.6527 8.43359 55.4893 12.1692 55.4893 16.771C55.4893 21.3729 51.6527 25.1085 46.9263 25.1085ZM46.9263 11.767C44.0905 11.767 41.7869 14.0099 41.7869 16.771C41.7869 19.5321 44.0905 21.775 46.9263 21.775C49.7621 21.775 52.0657 19.5321 52.0657 16.771C52.0657 14.0099 49.7621 11.767 46.9263 11.767Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.0251 23.4547C34.8111 23.4547 37.8803 20.4663 37.8803 16.7801C37.8803 13.0938 34.8111 10.1055 31.0251 10.1055C27.2391 10.1055 24.1699 13.0938 24.1699 16.7801C24.1699 20.4663 27.2391 23.4547 31.0251 23.4547Z",
			fill: "#E00303"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.024 25.1104C26.3056 25.1104 22.4609 21.3748 22.4609 16.773C22.4609 12.1712 26.2976 8.43555 31.024 8.43555C35.7503 8.43555 39.587 12.1712 39.587 16.773C39.587 21.3748 35.7503 25.1104 31.024 25.1104ZM31.024 11.769C28.1882 11.769 25.8846 14.0119 25.8846 16.773C25.8846 19.5341 28.1882 21.777 31.024 21.777C33.8598 21.777 36.1634 19.5341 36.1634 16.773C36.1634 14.0119 33.8598 11.769 31.024 11.769Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.966797 9.52539H4.76376L7.29772 18.5357L9.95877 9.52539H13.4142L16.2103 18.6594L18.7919 9.52539H22.3982L17.9022 24.0579H14.4468L11.6348 14.8852L8.92613 24.0579H5.47073L0.966797 9.52539Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.5234 9.52539H61.7502C66.5878 9.52539 69.7413 12.7815 69.7413 16.7878C69.7413 20.7941 66.5878 24.0502 61.7502 24.0502H56.5234V9.52539ZM65.8967 16.7878C65.8967 14.6299 64.4669 12.882 61.7423 12.882H60.3601V20.6858H61.7423C64.4748 20.6858 65.8967 18.9456 65.8967 16.78V16.7878Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.291 9.52539H82.0782V12.8898H75.1277V15.1095H81.4825V18.4738H75.1277V20.6935H82.1656V24.0579H71.291V9.52539Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.5179 15.442V24.0579H84.0625V9.52539H87.5179L94.2142 18.1413V9.52539H97.6696V24.0579H94.2142L87.5179 15.442Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.776 18.4661H103.85V24.0502H100.014V9.52539H103.85V15.1095H109.776V9.52539H113.613V24.0579H109.776V18.4738V18.4661Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.263 9.52539H123.718L129.477 24.0579H125.362L124.489 21.6294H119.095L118.221 24.0579H114.512L120.271 9.52539H120.263ZM123.329 18.4661L121.796 14.1891L120.239 18.4661H123.329Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.365 9.52539H135.735L138.444 16.7259L141.129 9.52539H146.689V24.0579H142.853V14.5294L140.056 21.6294H136.601L133.805 14.5294V24.0579H130.35V9.52539H130.365Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M148.207 19.4237H152.044C152.044 20.2977 152.981 21.1484 154.729 21.1484C155.984 21.1484 157.12 20.7153 157.12 19.9419C157.12 19.1144 155.817 18.7354 154.22 18.3023C151.726 17.6139 148.549 16.3919 148.549 13.5922C148.549 10.251 152.155 9.19141 154.538 9.19141C157.906 9.19141 160.615 11.2874 160.615 13.8861H156.778C156.778 13.2441 156.119 12.432 154.387 12.432C153.362 12.432 152.385 12.7259 152.385 13.4065C152.385 14.1954 153.664 14.5512 155.245 14.9843C157.739 15.6726 160.956 16.8946 160.956 19.7408C160.956 23.1052 157.35 24.3891 154.625 24.3891C151.043 24.3891 148.207 22.1694 148.207 19.4315V19.4237Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M165.903 12.8898H161.359V9.52539H174.275V12.8898H169.732V24.0579H165.895V12.8898H165.903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M175.285 9.52539H186.072V12.8898H179.122V15.1095H185.477V18.4738H179.122V20.6935H186.16V24.0579H175.285V9.52539Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M188.051 9.52539H195.406C198.282 9.52539 200.633 11.807 200.633 14.6145C200.633 16.5016 199.569 18.1645 197.972 19.0384L200.975 24.0579H196.733L194.135 19.6958H191.895V24.0579H188.059V9.52539H188.051ZM195.406 16.3315C196.177 16.3315 196.789 15.5658 196.789 14.6067C196.789 13.6477 196.169 12.882 195.406 12.882H191.887V16.3237H195.406V16.3315Z",
			fill: "black"
		})
	]
});
export default SvgWoodenhamsterLogo;
